import { NOTIFICATION_TYPE_BANK_MISMATCH } from '../../services/adminNotificationService';

export const NOTIFICATION_STATUS_TABS = [
  { key: 'open', label: 'Open' },
  { key: 'resolved', label: 'Resolved' },
  { key: 'all', label: 'All' },
];

const ENTITY_SEGMENT_LABELS = {
  investors: 'Investor',
  partners: 'Partner',
  suppliers: 'Supplier',
};

export function getEntitySegmentLabel(entitySegment) {
  return ENTITY_SEGMENT_LABELS[entitySegment] || entitySegment || '—';
}

export function formatNotificationTime(isoString) {
  if (!isoString) return '—';
  const date = new Date(isoString);
  if (Number.isNaN(date.getTime())) return '—';

  const now = Date.now();
  const diffMs = now - date.getTime();
  const diffMinutes = Math.floor(diffMs / 60000);

  if (diffMinutes < 1) return 'Just now';
  if (diffMinutes < 60) return `${diffMinutes}m ago`;

  const diffHours = Math.floor(diffMinutes / 60);
  if (diffHours < 24) return `${diffHours}h ago`;

  const diffDays = Math.floor(diffHours / 24);
  if (diffDays < 7) return `${diffDays}d ago`;

  return date.toLocaleString('en-IN', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

function buildPathFromActionUrl(actionUrl) {
  if (!actionUrl) return null;
  try {
    const url = new URL(actionUrl, window.location.origin);
    return `${url.pathname}${url.search}`;
  } catch {
    return null;
  }
}

export function getNotificationNavigationPath(notification) {
  if (!notification) return null;

  if (notification.notification_type === NOTIFICATION_TYPE_BANK_MISMATCH) {
    const { entity_segment: segment, metadata } = notification;
    const userUuid = metadata?.user_uuid;
    if (!userUuid) return buildPathFromActionUrl(notification.action_url);

    if (segment === 'investors') {
      const params = new URLSearchParams({ section: 'bank_details' });
      if (metadata?.partner_uuid) params.set('partner_uuid', metadata.partner_uuid);
      return `/investors/${userUuid}/profile?${params.toString()}`;
    }

    if (segment === 'suppliers') {
      return `/suppliers/${userUuid}/profile?section=bank_details`;
    }

    if (segment === 'partners') {
      return `/partner/details/${userUuid}?section=banks`;
    }
  }

  return buildPathFromActionUrl(notification.action_url);
}

export function countUnreadNotifications(notifications) {
  if (!Array.isArray(notifications)) return 0;
  return notifications.filter((item) => item?.is_read === false).length;
}
